import { render, staticRenderFns } from "./black.vue?vue&type=template&id=49a5dfa8&scoped=true&"
import script from "./black.vue?vue&type=script&lang=js&"
export * from "./black.vue?vue&type=script&lang=js&"
import style0 from "./black.vue?vue&type=style&index=0&id=49a5dfa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a5dfa8",
  null
  
)

export default component.exports